<template>
    <div class="selection:bg-brand-500 selection:text-on-brand pb-20">
        <!-- Hero Section -->
        <section class="relative overflow-hidden pt-20 pb-16 sm:pt-32 sm:pb-24">
            <div
                class="absolute inset-0 -z-10 bg-[radial-gradient(45%_45%_at_50%_50%,rgba(var(--core-brand-500),0.08)_0%,transparent_100%)]">
            </div>
            <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div class="text-center">
                    <div
                        class="inline-flex items-center gap-2 rounded-full border border-brand-200 bg-brand-50 px-3 py-1 text-sm font-medium text-brand-600 mb-8 dark:border-brand-500/20 dark:bg-brand-500/10">
                        <span class="relative flex h-2 w-2">
                            <span
                                class="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-400 opacity-75"></span>
                            <span class="relative inline-flex h-2 w-2 rounded-full bg-brand-500"></span>
                        </span>
                        New features just released
                    </div>
                    <h1 class="mx-auto max-w-4xl text-5xl font-extrabold tracking-tight text-header sm:text-7xl">
                        Elevate Your Experience with <span
                            class="bg-gradient-to-r to-brand-500 via-primary-500 from-secondary-500 bg-clip-text text-transparent font-extrabold">Premium
                            Membership</span>
                    </h1>
                    <p class="mx-auto mt-6 max-w-2xl text-lg leading-8">
                        Join thousands of professionals who have unlocked the full potential of Dephics. Get exclusive
                        access,
                        faster processing, and dedicated support.
                    </p>
                    <!-- <div class="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
                        <button @click="router.push('/member-registration')"
                            class="group flex items-center gap-2 rounded-2xl bg-brand-500 px-8 py-4 text-lg font-bold text-white transition-all hover:bg-brand-600 hover:shadow-xl hover:shadow-brand-500/30 active:scale-95">
                            Get Started for Free
                            <ArrowRight class="h-5 w-5 transition-transform group-hover:translate-x-1" />
                        </button>
                        <div class="flex items-center gap-2">
                            <div class="flex -space-x-2">
                                <img v-for="i in 4" :key="i" :src="`https://i.pravatar.cc/100?u=${i}`"
                                class="h-10 w-10 rounded-full border-2 border-app bg-muted ring-2 ring-transparent transition-transform hover:z-10 hover:scale-110" />
                            </div>
                            <span class="text-sm font-medium text-body/80">Join 10k+ members</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </section>

        <!-- Features Section -->
        <!-- <section id="features" class="py-24 bg-body">
            <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div class="mb-16 text-center">
                    <h2 class="text-base font-semibold leading-7 text-brand-500 uppercase tracking-widest">Why Join Us?</h2>
                    <p class="mt-2 text-3xl font-bold tracking-tight text-header sm:text-4xl">Everything you need to succeed</p>
                </div>
                <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                    <div v-for="feature in features" :key="feature.name" class="group relative rounded-3xl border border-app bg-card p-8 transition-all hover:border-brand-500/50 hover:shadow-2xl hover:shadow-brand-500/5">
                        <div class="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-500/10 text-brand-500 transition-colors group-hover:bg-brand-500 group-hover:text-white">
                            <component :is="feature.icon" class="h-6 w-6" />
                        </div>
                        <h3 class="text-xl font-bold text-header">{{ feature.name }}</h3>
                        <p class="mt-4 text-body/80 leading-relaxed">{{ feature.description }}</p>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- Pricing Section -->
        <section id="pricing" class="py-24 overflow-hidden">
            <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div class="mb-16 text-center">
                    <h2 class="text-3xl font-bold tracking-tight text-header sm:text-4xl">Simple, Transparent Pricing
                    </h2>
                    <p class="mt-4 text-lg">Choose the plan that's right for you</p>

                    <div class="mt-8 inline-flex items-center rounded-full bg-body p-1 border border-app">
                        <button @click="billingCycle = 'monthly'"
                            :class="billingCycle === 'monthly' ? 'bg-card text-header shadow-sm' : 'text-body/80'"
                            class="rounded-full px-6 py-2 text-sm font-semibold transition-all">Monthly</button>
                        <button @click="billingCycle = 'yearly'"
                            :class="billingCycle === 'yearly' ? 'bg-brand-500 text-on-brand shadow-sm shadow-brand-500/20' : 'text-body/80'"
                            class="rounded-full px-6 py-2 text-sm font-semibold transition-all flex items-center gap-2">
                            Yearly
                            <span
                                class="rounded bg-success-500/20 px-1.5 py-0.5 text-[10px] font-bold text-success-600 uppercase">Save
                                20%</span>
                        </button>
                    </div>
                </div>

                <div class="grid grid-cols-1 gap-8 lg:grid-cols-3">
                    <div v-for="plan in plans" :key="plan.name" :class="[
                        plan.highlight ? 'ring-4 ring-brand-500 ring-opacity-20 translate-y-[-16px] z-10 scale-105' : '',
                        'relative flex flex-col rounded-3xl border border-app bg-card p-10 transition-all hover:shadow-2xl'
                    ]">
                        <div v-if="plan.highlight"
                            class="absolute inset-x-0 -top-4 mx-auto w-fit rounded-full bg-brand-500 px-4 py-1 text-xs font-bold uppercase tracking-wider text-on-brand">
                            Most Popular
                        </div>
                        <div class="mb-8">
                            <h3 class="text-2xl font-bold text-header">{{ plan.name }}</h3>
                            <p class="mt-2 text-body/80">{{ plan.description }}</p>
                        </div>
                        <div class="mb-8 flex items-baseline gap-1">
                            <span class="text-4xl font-extrabold text-header">${{ billingCycle === 'monthly' ?
                                plan.price.monthly :
                                plan.price.yearly }}</span>
                            <span class="text-body/80">/{{ billingCycle === 'monthly' ? 'mo' : 'yr' }}</span>
                        </div>
                        <ul class="mb-10 space-y-4 flex-grow">
                            <li v-for="feature in plan.features" :key="feature"
                                class="flex items-center gap-3 text-sm text-header">
                                <Check class="h-5 w-5 flex-shrink-0 text-success-500" />
                                {{ feature }}
                            </li>
                            <li v-for="feature in plan.excluded" :key="feature"
                                class="flex items-center gap-3 text-sm text-body/80 line-through opacity-50">
                                <Check class="h-4 w-4 flex-shrink-0" />
                                {{ feature }}
                            </li>
                        </ul>
                        <button @click="selectPlan(plan)"
                            :class="plan.highlight ? 'bg-brand-500 text-on-brand hover:bg-brand-600 shadow-lg shadow-brand-500/25' : 'bg-body text-header border border-app hover:bg-muted'"
                            class="w-full rounded-2xl py-4 text-base font-bold transition-all active:scale-95">
                            {{ plan.cta }}
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <!-- FAQ Section -->
        <section id="faq" class="py-24 bg-body/50">
            <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
                <h2 class="text-3xl font-bold tracking-tight text-header mb-12">Frequently Asked Questions</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-left max-w-4xl mx-auto">
                    <div v-for="faq in faqs" :key="faq.q" class="bg-card p-6 rounded-2xl border border-app">
                        <h4 class="font-bold text-header mb-2">{{ faq.q }}</h4>
                        <p class="text-body/80 text-sm leading-relaxed">{{ faq.a }}</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {
    Zap,
    Check,
    ArrowRight,
    Shield,
    Star,
    Layers,
    Smartphone,
    Globe,
    Users
} from 'lucide-vue-next'
import { fetchMembershipTypes } from '~/utils/api'

definePageMeta({ name: 'Membership' })

const router = useRouter()
const billingCycle = ref<'monthly' | 'yearly'>('monthly')

const features = [
    {
        name: 'Unified Access',
        description: 'Get single sign-on access across all Dephics modules including Promo, SMS, and Resources.',
        icon: Layers,
    },
    {
        name: 'Global Reach',
        description: 'Scale your business globally with multi-region support and localized experiences.',
        icon: Globe,
    },
    {
        name: 'Priority Support',
        description: 'Our dedicated team is available 24/7 to help you with any technical or business needs.',
        icon: Star,
    },
    {
        name: 'Advanced Security',
        description: 'Bespoke security protocols and encrypted data storage to keep your business safe.',
        icon: Shield,
    },
    {
        name: 'Mobile Optimized',
        description: 'Manage your membership on the go with our fully responsive mobile platform.',
        icon: Smartphone,
    },
    {
        name: 'Team Collaboration',
        description: 'Invite team members and manage roles with granular permission controls.',
        icon: Users,
    },
]

const plans = [
    {
        id: 'starter',
        name: 'Starter',
        description: 'Perfect for individuals and small startups.',
        price: { monthly: 0, yearly: 0 },
        features: ['Basic access to all modules', '5 projects per month', 'Community support', 'Standard storage (1GB)'],
        excluded: ['Priority processing', 'Custom domain', 'API access'],
        highlight: false,
        cta: 'Start for Free',
    },
    {
        id: 'pro',
        name: 'Professional',
        description: 'Ideal for growing teams and businesses.',
        price: { monthly: 29, yearly: 290 },
        features: ['Unlimited module access', '50 projects per month', 'Email & Chat support', 'Premium storage (10GB)', 'Priority processing'],
        excluded: ['Custom domain', 'API access'],
        highlight: true,
        cta: 'Get Started',
    },
    {
        id: 'enterprise',
        name: 'Enterprise',
        description: 'For large organizations requiring scale.',
        price: { monthly: 99, yearly: 990 },
        features: ['Unlimited everything', 'Dedicated account manager', '24/7 Phone support', 'Unlimited storage', 'Custom domain', 'Full API access', 'SLA guaranteed'],
        excluded: [],
        highlight: false,
        cta: 'Contact Sales',
    },
]

const faqs = [
    { q: "Can I cancel my subscription any time?", a: "Yes, you can cancel your subscription at any time from your account settings. You'll retain access until the end of your billing period." },
    { q: "Do you offer discounts for educational institutions?", a: "Absolutely! Contact our sales team with your proof of status and we'll set you up with a custom plan." },
    { q: "Which modules are included in the Free tier?", a: "The Free tier includes basic access to Public, Promo, and Resources. Advanced modules like SMS require a paid plan." },
    { q: "Is my data secure?", a: "We use bank-level encryption and follow strict compliance standards to ensure your data stays private and secure." }
]

const selectPlan = (plan: any) => {
    router.push({
        path: '/member-registration',
        query: { plan: plan.id, cycle: billingCycle.value }
    })
}


const { data: membershipTypes } = useAsyncData('membership-types', (): Promise<any[]> => fetchMembershipTypes(), {
    lazy: true,
    default: () => [],
});
</script>

<style scoped>
.text-header {
    color: rgb(var(--core-header-text));
}

.text-muted {
    color: rgb(var(--core-muted-text));
}

.bg-body {
    background-color: rgb(var(--core-body-bg));
}

.bg-card {
    background-color: rgb(var(--core-card-bg));
}

.border-app {
    border-color: rgb(var(--core-app-border));
}
</style>
